import {
    CLEAR_SESSION,
    ADD_FAVOURITE_ORG_SURVEY,
    FETCH_ALL_ORG_SURVEY_SUCCESS,
    FILTER_ORG_SURVEY,
    GET_ALL_ORG_SURVEY,
    GET_UNSELECTED_ALL_ORG_SURVEY,
    HANDLE_ORG_SURVEY_REQUEST_CLOSE,
    HIDE_ORG_SURVEY_LOADER,
    SHOW_ORG_SURVEY_LOADER,
    ON_ADD_ORG_SURVEY,
    ON_ALL_ORG_SURVEY_SELECT,
    ON_ORG_SURVEY_CLOSE,
    ON_ORG_SURVEY_SELECT,
    ON_DELETE_ORG_SURVEY,
    ON_DELETE_SELECTED_ORG_SURVEY,
    ON_FILTER_ORG_SURVEY_OPTION_SELECT,
    ON_SAVE_ORG_SURVEY_SUCCESS,
    ON_TOGGLE_ORG_SURVEY_DRAWER,
    SHOW_ORG_SURVEY_MESSAGE,
    UPDATE_SEARCH_ORG_SURVEY,
    ON_ORG_SURVEY_QUESTIONS,
    ON_ORG_SURVEY_COMPARE_SELECT,
    FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS,
    FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';

const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No surveys found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: 'All surveys',
    allOrgSurvey: [],
    orgSurveyList: [],
    orgSurveyCompareRadarChartData: [],
    orgSurveyCompareDistributionsChartData: [],
    orgSurveyCompareTopResultsChartData: [],
    orgSurveyCompareBottomResultsChartData: [],
    orgSurveyCompareList: [],
    selectedOrgSurveysCompare: [],
    selectedOrgSurvey: null,
    selectedOrgSurveys: [],
    addOrgSurveyState: false,
    searchOrgSurvey: '',
    orgSurvey: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedOrgSurvey: null,
            };
        }
        case FETCH_ALL_ORG_SURVEY_COMPARE_SUCCESS: {
            return {
                ...state,
                loader: false,
                orgSurveyCompareList: action.payload,
            };
        }
        case FETCH_ALL_ORG_SURVEY_ENGAGEMENT_REPORT_CHART_DATA_SUCCESS: {
            const { payload } = action;
            const { topResultsChartData, bottomResultsChartData, distributionsReportData } = payload;
            return {
                ...state,
                loader: false,
                orgSurveyCompareDistributionsChartData: distributionsReportData,
                orgSurveyCompareTopResultsChartData: topResultsChartData,
                orgSurveyCompareBottomResultsChartData: bottomResultsChartData,
            };
        }
        case FETCH_ALL_ORG_SURVEY_COMPARE_RADAR_CHART_DATA_SUCCESS: {
            return {
                ...state,
                loader: false,
                orgSurveyCompareRadarChartData: action.payload,
            };
        }
        case FETCH_ALL_ORG_SURVEY_COMPARE_DISTRIBUTIONS_CHART_DATA_SUCCESS: {
            return {
                ...state,
                loader: false,
                orgSurveyCompareDistributionsChartData: action.payload,
            };
        }
        case FETCH_ALL_ORG_SURVEY_COMPARE_TOP_RESULTS_CHART_DATA_SUCCESS: {
            return {
                ...state,
                loader: false,
                orgSurveyCompareTopResultsChartData: action.payload,
            };
        }
        case FETCH_ALL_ORG_SURVEY_COMPARE_BOTTOM_RESULTS_CHART_DATA_SUCCESS: {
            return {
                ...state,
                loader: false,
                orgSurveyCompareBottomResultsChartData: action.payload,
            };
        }
        case ON_ORG_SURVEY_COMPARE_SELECT: {
            let { payload } = action;
            if (payload ?.selected) {
                payload.selected = !payload.selected;
            } else {
                // add selected to the payload
                payload = {
                    ...payload,
                    selected: true,
                };
            }
            const selectedOrgSurveysCompare = state.orgSurveyCompareList.map((orgSurvey) => {
                if (orgSurvey.id === payload.id) {
                    return payload;
                } else {
                    return orgSurvey;
                }
            });
            return {
                ...state,
                INIT_STATE,
                orgSurveyCompareList: selectedOrgSurveysCompare
            };
        }
        case ADD_FAVOURITE_ORG_SURVEY: {
            return {
                ...state,
                alertMessage: action.payload.starred ? 'Survey removed as star' : 'Survey marked as star',
                showMessage: true,
                orgSurveyList: state.orgSurveyList.map((orgSurvey) => orgSurvey.id === action.payload.id ? {
                    ...orgSurvey,
                    starred: !action.payload.starred
                } : orgSurvey),
                allOrgSurvey: state.allOrgSurvey.map((orgSurvey) => orgSurvey.id === action.payload.id ? {
                    ...orgSurvey,
                    starred: !action.payload.starred
                } : orgSurvey)
            };
        }
        case FETCH_ALL_ORG_SURVEY_SUCCESS: {
            return {
                ...state,
                loader: false,
                allOrgSurvey: action.payload,
                orgSurveyList: action.payload,
            };
        }
        case SHOW_ORG_SURVEY_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_ORG_SURVEY_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedOrgSurveys = 0;
            const orgSurveyList = state.orgSurveyList.map(orgSurvey => {
                if (orgSurvey.selected) {
                    selectedOrgSurveys++;
                }
                if (orgSurvey.id === action.payload.id) {
                    if (orgSurvey.selected) {
                        selectedOrgSurveys++;
                    }
                    return action.payload;
                } else {
                    return orgSurvey;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedOrgSurveys: selectedOrgSurveys,
                orgSurveyList: orgSurveyList
            };
        }
        case ON_ADD_ORG_SURVEY: {
            return { ...state, addOrgSurveyState: true };
        }
        case ON_ORG_SURVEY_CLOSE: {
            return { ...state, addOrgSurveyState: false };
        }
        case ON_FILTER_ORG_SURVEY_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let orgSurveyList = [];
            switch (action.payload.name) {
                case 'All surveys': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    orgSurveyList = state.allOrgSurvey;
                    break;
                }
                case 'Frequently accessed': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    orgSurveyList = state.allOrgSurvey.filter((orgSurvey) => orgSurvey.frequently);
                    break;
                }
                case 'Starred surveys': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    orgSurveyList = state.allOrgSurvey.filter((orgSurvey) => orgSurvey.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, orgSurveyList, drawerState: false
            };
        }
        case ON_SAVE_ORG_SURVEY_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Survey Updated Successfully',
                showMessage: true,
                orgSurveyList: action.payload,
                allOrgSurvey: action.payload,
                loader: false,
            };
        }
        case ON_DELETE_ORG_SURVEY: {
            return {
                ...state,
                alertMessage: 'Survey Deleted Successfully',
                showMessage: true,
                allOrgSurvey: state.allOrgSurvey.filter((orgSurvey) => orgSurvey.id !== action.payload.id),
                orgSurveyList: state.allOrgSurvey.filter((orgSurvey) => orgSurvey.id !== action.payload.id),
            };
        }
        case ON_DELETE_SELECTED_ORG_SURVEY: {
            const orgSurveys = state.allOrgSurvey.filter((orgSurvey) => !orgSurvey.selected);
            return {
                ...state,
                alertMessage: 'Survey Deleted Successfully',
                showMessage: true,
                allOrgSurvey: orgSurveys,
                orgSurveyList: orgSurveys,
                selectedOrgSurveys: 0
            };
        }
        case FILTER_ORG_SURVEY: {
            const { filterOption } = state;
            let orgSurveyList = [];
            if (action.payload === '') {
                orgSurveyList = state.allOrgSurvey;
            } else {
                const filterOrgSurvey = state.allOrgSurvey.filter((orgSurvey) =>
                    orgSurvey.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === 'All surveys') {
                    orgSurveyList = filterOrgSurvey;
                } else if (filterOption === 'Frequently accessed') {
                    orgSurveyList = filterOrgSurvey.filter((orgSurvey) => orgSurvey.frequently);
                } else if (filterOption === 'Starred surveys') {
                    orgSurveyList = filterOrgSurvey.filter((orgSurvey) => orgSurvey.starred);
                }
            }
            return { ...state, orgSurveyList: orgSurveyList };
        }
        case GET_ALL_ORG_SURVEY: {
            let orgSurveyList = state.allOrgSurvey.map((orgSurvey) => orgSurvey ? {
                ...orgSurvey,
                selected: true
            } : orgSurvey);
            return {
                ...state,
                selectedOrgSurveys: orgSurveyList.length,
                allOrgSurvey: orgSurveyList,
                orgSurveyList: orgSurveyList
            };
        }
        case GET_UNSELECTED_ALL_ORG_SURVEY: {
            let orgSurveyList = state.allOrgSurvey.map((orgSurvey) => orgSurvey ? {
                ...orgSurvey,
                selected: false
            } : orgSurvey);
            return {
                ...state,
                selectedOrgSurveys: 0,
                allOrgSurvey: orgSurveyList,
                orgSurveyList: orgSurveyList
            };
        }
        case ON_ALL_ORG_SURVEY_SELECT: {
            const selectAll = state.selectedOrgSurveys < state.orgSurveyList.length;
            let selectedOrgSurveys = 0;
            let orgSurveyList = [];
            if (selectAll) {
                orgSurveyList = state.allOrgSurvey.map((orgSurvey) => orgSurvey ? {
                    ...orgSurvey,
                    selected: true
                } : orgSurvey);
                selectedOrgSurveys = orgSurveyList.length;
            } else {
                orgSurveyList = state.allOrgSurvey.map((orgSurvey) => orgSurvey ? {
                    ...orgSurvey,
                    selected: true
                } : orgSurvey);
                selectedOrgSurveys = 0;
            }
            return {
                ...state,
                selectedOrgSurveys: selectedOrgSurveys,
                allOrgSurvey: orgSurveyList,
                orgSurveyList: orgSurveyList
            };
        }
        case UPDATE_SEARCH_ORG_SURVEY: {
            return { ...state, searchOrgSurvey: action.payload };
        }
        case HANDLE_ORG_SURVEY_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_ORG_SURVEY_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_ORG_SURVEY_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_ORG_SURVEY_LOADER: {
            return { ...state, loader: false };
        }
        case ON_ORG_SURVEY_QUESTIONS: {
            return { ...state, loader: false, selectedOrgSurvey: action.payload };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/OrgSurvey.js